import { Linkedin } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

import aubinGonzalez from "@/assets/aubin-gonzalez.jpeg";
import ulianaLutchyn from "@/assets/uliana-lutchyn.jpeg";

const teamMembers = [
  {
    name: "Aubin Gonzalez",
    title: "Founding Partner",
    bio: "International legal advisor with a background supporting European institutions, multinational companies, and cross-border initiatives. Experienced in regulatory governance, compliance, and institutional strategy across Europe and Africa.",
    image: aubinGonzalez,
    initials: "AG",
    linkedin: "https://www.linkedin.com/in/aubin-gonzalez-lapos-19736848/",
  },
  {
    name: "Uliana Lutchyn",
    title: "Founding Partner",
    bio: "Business development and operations leader specializing in UK market expansion, fundraising processes, and legal-operations infrastructure. Former Head of Ops at a Y Combinator-backed startup and ex-legal counsel at leading tech and law firms.",
    image: ulianaLutchyn,
    initials: "UL",
    linkedin: "https://www.linkedin.com/in/uliana-lutchyn/",
  },
];

const Team = () => {
  return (
    <section id="team" className="py-24 md:py-32 bg-background">
      <div className="container px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
              Our Team
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Experienced advisors with deep expertise in deep-tech, defense, and strategic capital raising.
            </p>
          </div>

          {/* Team grid */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="group bg-card border border-border rounded-xl p-6 md:p-8 text-center hover:border-primary/30 hover:shadow-lg transition-all duration-300"
              >
                {/* Avatar */}
                <Avatar className="w-24 h-24 md:w-32 md:h-32 mx-auto mb-4 md:mb-6 ring-2 ring-primary/20 group-hover:ring-primary/40 transition-all">
                  <AvatarImage src={member.image} alt={member.name} />
                  <AvatarFallback className="bg-muted text-muted-foreground text-xl font-semibold">
                    {member.initials}
                  </AvatarFallback>
                </Avatar>

                {/* Name & Title */}
                <h3 className="font-display text-lg md:text-xl font-semibold text-foreground mb-1">{member.name}</h3>
                <p className="text-primary font-medium mb-3 md:mb-4">{member.title}</p>

                {/* Bio */}
                <p className="text-muted-foreground text-xs md:text-sm leading-relaxed mb-4 md:mb-6">{member.bio}</p>

                {/* LinkedIn Button */}
                <Button variant="outline" size="sm" className="gap-2 min-h-[44px]" asChild>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                    <Linkedin className="w-4 h-4" />
                    LinkedIn
                  </a>
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
